// vendor
import HashID from 'hashids';

// local application
import { environment } from '@env';

// for backend api number encryption
const hashKey = new HashID(
  environment.hashKeys.salt,
  environment.hashKeys.keyLength,
  environment.hashKeys.secretKey
);

export const hashConfig = {
  encrypt: (data: number | Array<string>) => {
    try {
      if (!Array.isArray(data)) {
        return hashKey.encode(data);
      }

      if (data.length > 1) {
        return data.map((e) => hashKey.encode(e)).join('/');
      }
      return hashKey.encode(data[0]);
    } catch (error) {
      console.error('Unable to encrypt value');
      return '';
    }
  },
  decrypt: (encryptedData: string | Array<string>) => {
    try {
      if (!Array.isArray(encryptedData)) {
        return hashKey.decode(encryptedData);
      }

      return encryptedData.map((e) => hashKey.decode(e)).join('/');
    } catch (error) {
      console.error('Unable to decrypt hashed value');
      return '';
    }
  },
};
